var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardLogoAmex = function SvgCardLogoAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#card-logo-amex_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 35.636,
    fill: "#fff",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#card-logo-amex_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006FCF",
    d: "m49.643 8.745 1.14-3.1H56V0H0v35.636h56v-5.63h-4.918l-1.817-2.124-1.889 2.124h-13.97V18.688h-4.61L34.56 5.645h5.61l1.354 2.958V5.645h6.963l1.162 3.1zm-3.928 2.053-.014-1.247.478 1.247 2.316 6.186h2.302l2.33-6.186.45-1.233v7.426H56v-9.5h-4.027l-1.832 4.825-.484 1.304-.5-1.304L47.32 7.49h-4.027v9.5h2.423v-6.193m-5.217 6.186h2.794l-4.184-9.5h-3.242l-4.206 9.5h2.759l.734-1.831h4.611zm-3.514-6.279.478-1.19.477 1.19.984 2.402h-2.922zm-1.632 7.99v9.465h7.933v-2.053h-5.51v-1.653h5.403v-2.046h-5.402v-1.66h5.509v-2.053zm16.764 9.472h3.15l-4.44-4.754 4.44-4.718h-3.1L49.3 21.774l-2.85-3.08h-3.158l4.433 4.755-4.433 4.718h3.065l2.886-3.086zm1.197-4.768L56 26.129v-5.431l-2.687 2.694z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "card-logo-amex_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 35.636,
    fill: "#fff",
    rx: 6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "card-logo-amex_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v35.636H0z"
  })))));
};
export default SvgCardLogoAmex;